module.exports = __webpack_public_path__ + "img/source-close.2875ff74.png";